
/**
 * createAction
 * 
 * Creates a standardized action object with optional defaults.
 * Each action has the same set of methods (fetch, set, render) unless overridden.
 * 
 * @param {string} name - Name of the action (for debugging / clarity)
 * @param {Object} handlers - Optional handlers to override defaults
 * @param {Function} handlers.fetch - Fetch handler
 * @param {Function} handlers.set - Set handler
 * @param {Function} handlers.render - Render handler
 * @returns {Object} Standardized action object
 */
export function createAction(name, handlers = {}) {
    const defaults = {
        fetch: (...args) => {
            console.warn(`Action "${name}" fetch() not implemented. Arguments:`, args);
        },
        set: (...args) => {
            console.warn(`Action "${name}" set() not implemented. Arguments:`, args);
        },
        render: (...args) => {
            console.warn(`Action "${name}" render() not implemented. Arguments:`, args);
        }
    };

    const action = {};
    for (const key of Object.keys(defaults)) {
        action[key] = (...args) => {
            const fn = handlers[key] || defaults[key];
            return fn(...args);
        };
    }

    return action;
}

